/* bristm-timeline — scroll-drawn line + dots lighting up (loaded only where the section renders)
 * The lime line fills with scroll progress through the track; each milestone's
 * dots light up once the line reaches them. Work only runs while the section
 * is on screen (IntersectionObserver) and is batched in rAF (reads, then writes).
 * Reduced motion / no IntersectionObserver: line and dots stay fully lit. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(section) {
    if (section.dataset.bTlBound) return;
    section.dataset.bTlBound = '1';
    if (reduce || !('IntersectionObserver' in window)) return;
    if (document.documentElement.classList.contains('shopify-design-mode')) return;

    var track = section.querySelector('[data-b-timeline-track]');
    var fill = section.querySelector('[data-b-timeline-fill]');
    if (!track || !fill) return;
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-b-timeline-item]'));
    var dots = items.map(function (item) {
      return item.querySelector('[data-b-timeline-dot]');
    });

    var active = false;
    var ticking = false;
    var lit = items.map(function () {
      return false;
    });

    section.classList.add('is-tracking');
    fill.style.setProperty('--b-tl-p', '0');

    function update() {
      ticking = false;
      // Reads
      var vh = window.innerHeight;
      var rect = track.getBoundingClientRect();
      var lineTop = rect.top + 23;
      var height = rect.bottom - lineTop;
      var drawTo = vh * 0.62;
      var p = height > 0 ? (drawTo - lineTop) / height : 1;
      p = Math.max(0, Math.min(1, p));
      var tip = lineTop + p * height;
      var states = dots.map(function (dot) {
        if (!dot) return false;
        return dot.getBoundingClientRect().top <= tip + 1;
      });
      // Writes
      fill.style.setProperty('--b-tl-p', p.toFixed(4));
      section.classList.toggle('is-done', p >= 1);
      states.forEach(function (on, i) {
        if (on !== lit[i]) {
          lit[i] = on;
          items[i].classList.toggle('is-lit', on);
        }
      });
    }

    function onScroll() {
      if (!active || ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    var io = new IntersectionObserver(
      function (entries) {
        active = entries[0].isIntersecting;
        if (active) onScroll();
      },
      { rootMargin: '10% 0px 10% 0px' }
    );
    io.observe(track);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-b-timeline]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
